import React from "react";
import { NavLink } from "react-router-dom";
import { House, CalendarCheck, ClipboardText, Airplane, Money } from "@phosphor-icons/react";

const TABS = [
  { to: "/", label: "Home", icon: House, testId: "tab-home" },
  { to: "/attendance", label: "Attendance", icon: CalendarCheck, testId: "tab-attendance" },
  { to: "/reports", label: "Reports", icon: ClipboardText, testId: "tab-reports" },
  { to: "/payroll", label: "Payroll", icon: Money, testId: "tab-payroll" },
  { to: "/leaves", label: "Leaves", icon: Airplane, testId: "tab-leaves" },
];

export default function BottomTabBar() {
  return (
    <nav
      data-testid="bottom-tab-bar"
      className="md:hidden fixed bottom-0 inset-x-0 bg-white border-t border-[#E5E7EB] z-40 grid grid-cols-5"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {TABS.map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.to === "/"}
            data-testid={t.testId}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] font-medium transition-colors duration-200 border-t-2 ${
                isActive
                  ? "border-[#106109] text-[#106109]"
                  : "border-transparent text-[#6B7280] hover:text-[#111827]"
              }`
            }
          >
            <Icon size={20} weight="regular" />
            {t.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
